import React, { useEffect, useState } from 'react';
import './App.css';
import './Layout.css';
import './cssConfig/MonthFormConfig.css';
import './cssConfig/TopbarConfig.css';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Signin from './containers/homepage/signin/Signin';
import Signup from './containers/homepage/signup/Signup';
import HomeContainer from './containers/HomeContainer';
import ToastContainer from './components/common/Toast';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { SessionExpiredModal } from './components/common/modal/SessionExpiredModal';
import { setSessionExpiredModalHandler } from './utils/axios/axiosInterceptor';
import { tokenExpiryManager } from './utils/tokenExpiryManager';
import { setSessionErrorModalHandler, handleGlobalError } from './utils/auth/sessionErrorHandler';
import { hasTokens } from './utils/auth/tokenValidator';


// [수정] 모든 import가 끝난 후 모듈 등록 실행
ModuleRegistry.registerModules([AllCommunityModule]);


function App() {
    const [isSessionModalOpen, setIsSessionModalOpen] = useState(false);
    const [sessionModalMessage, setSessionModalMessage] = useState('세션이 만료되었습니다. 다시 로그인해주세요.');

    const setScreenHeight = () => {
        document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`);
    }

    useEffect(() => {
        setScreenHeight();
        // resize 이벤트가 발생하면 다시 계산하도록 아래 코드 추가
        window.addEventListener('resize', setScreenHeight);

        // React 개발 서버의 에러 오버레이 숨기기
        const hideErrorOverlay = () => {
            const errorOverlay = document.querySelector('[data-react-error-overlay]') ||
                document.querySelector('iframe[src*="react-error-overlay"]') ||
                document.querySelector('div[style*="position: fixed"][style*="z-index: 999999"]');
            if (errorOverlay) {
                (errorOverlay as HTMLElement).style.display = 'none';
            }
        };

        // 즉시 실행 및 주기적 체크
        hideErrorOverlay();
        const interval = setInterval(hideErrorOverlay, 100);

        return () => {
            window.removeEventListener('resize', setScreenHeight);
            clearInterval(interval);
        };
    }, [])

    // 세션 만료 모달 핸들러 설정
    useEffect(() => {
        const handleSessionExpired = (message?: string) => {
            if (message) {
                setSessionModalMessage(message);
            }
            setIsSessionModalOpen(true);
        };

        // 기존 핸들러와 새로운 핸들러 모두 설정
        setSessionExpiredModalHandler(handleSessionExpired);
        setSessionErrorModalHandler(handleSessionExpired);

        // 전역 에러 핸들러 추가 (통합된 에러 처리 사용)
        const handleErrorEvent = (event: ErrorEvent) => {
            handleGlobalError(event, 'global-error');
        };

        const handleRejectionEvent = (event: PromiseRejectionEvent) => {
            handleGlobalError(event, 'global-error');
        };

        window.addEventListener('error', handleErrorEvent);
        window.addEventListener('unhandledrejection', handleRejectionEvent);

        // 토큰 만료 매니저 연결: 초기화 및 콜백 등록
        tokenExpiryManager.initFromStorage();
        // 만료 임박 알림 비활성화: 페이지 진입 직후 팝업 방지
        tokenExpiryManager.setWarnLeadTime(0);
        const unsubExpired = tokenExpiryManager.onExpired(() => {
            // 토큰이 있는 상태에서 만료된 경우에만 모달 표시
            if (hasTokens()) {
                setSessionModalMessage('세션이 만료되었습니다. 다시 로그인해주세요.');
                setIsSessionModalOpen(true);
            } else {
                // 토큰이 없으면 조용히 로그인 페이지로
                localStorage.removeItem('access-token');
                localStorage.removeItem('refresh-token');
                localStorage.removeItem('access-exp');
                localStorage.removeItem('refresh-exp');
                window.location.assign("/signin");
            }
        });

        const handleFocus = () => tokenExpiryManager.handleVisibilityOrFocusCheck();
        const handleVisibility = () => tokenExpiryManager.handleVisibilityOrFocusCheck();
        window.addEventListener('focus', handleFocus);
        document.addEventListener('visibilitychange', handleVisibility);
        // 현재 저장된 토큰 기준으로 타이머 설정
        try {
            const at = localStorage.getItem('access-token');
            const rt = localStorage.getItem('refresh-token');
            if (at || rt) tokenExpiryManager.setTokens(at, rt);
        } catch {}

        return () => {
            window.removeEventListener('error', handleErrorEvent);
            window.removeEventListener('unhandledrejection', handleRejectionEvent);
            window.removeEventListener('focus', handleFocus);
            document.removeEventListener('visibilitychange', handleVisibility);
            unsubExpired();
        };
    }, []);

    const handleSessionModalConfirm = () => {
        localStorage.removeItem('access-token');
        localStorage.removeItem('refresh-token');
        localStorage.removeItem('access-exp');
        localStorage.removeItem('refresh-exp');
        // 완전히 새로운 페이지로 이동하여 순환 참조 방지
        window.location.assign("/signin");
    };

    // const handleSessionModalCancel = () => {
    //   setIsSessionModalOpen(false);
    // };

    return (
        <BrowserRouter basename='/'>
            <Routes>
                <Route path="/signin" element={<Signin />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/" element={<HomeContainer />} />
            </Routes>
            <ToastContainer />
            <SessionExpiredModal
                isOpen={isSessionModalOpen}
                onConfirm={handleSessionModalConfirm}
                // onCancel={handleSessionModalCancel}
                message={sessionModalMessage}
            />
        </BrowserRouter>
    );
}

export default App;
